export default __webpack_public_path__ + "static/media/logo_dark.ede04756.png";